import { render } from "./CustomLoader.vue?vue&type=template&id=7e1ab6b2&scoped=true"
const script = {}

import "./CustomLoader.vue?vue&type=style&index=0&id=7e1ab6b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1ab6b2"]])

export default __exports__